import { MedicalServices, MonitorHeart } from "@mui/icons-material";
import { Box, SvgIcon, Tooltip, alpha } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { StethoscopeIcon } from "../../components/UI/Menus/DynamicIcon";

const translation_path = "page.doctorAgenda.scheduleType.";

export const TasyScheduleType = {
  SURGERY: 1,
  EXAM: 2,
  CONSULTATION: 3,
} as const;

interface IScheduleTypeConfig {
  element: ReactNode;
  color: string;
  translationKey: string;
}

const SCHEDULE_TYPE_ICONS: Record<number, IScheduleTypeConfig> = {
  [TasyScheduleType.CONSULTATION]: {
    element: <SvgIcon component={StethoscopeIcon} inheritViewBox />,
    color: "#0288d1",
    translationKey: "consultation",
  },
  [TasyScheduleType.EXAM]: {
    element: <MonitorHeart />,
    color: "#2e7d32",
    translationKey: "exam",
  },
  [TasyScheduleType.SURGERY]: {
    element: <MedicalServices />,
    color: "#d32f2f",
    translationKey: "surgery",
  },
};

export const SCHEDULE_TYPE_LIST = [
  { code: TasyScheduleType.CONSULTATION, translationKey: "consultation" },
  { code: TasyScheduleType.EXAM, translationKey: "exam" },
  { code: TasyScheduleType.SURGERY, translationKey: "surgery" },
];

interface IScheduleTypeIconProps {
  tasyScheduleTypeCode: number;
  size?: number;
  disableTooltip?: boolean;
}

const ScheduleTypeIcon = ({
  tasyScheduleTypeCode,
  size = 40,
  disableTooltip = false,
}: IScheduleTypeIconProps) => {
  const { t } = useTranslation();

  const config = SCHEDULE_TYPE_ICONS[tasyScheduleTypeCode];

  if (!config) return null;

  const badge = (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: alpha(config.color, 0.12),
        color: config.color,
        "& .MuiSvgIcon-root": {
          fontSize: size * 0.55,
        },
      }}
    >
      {config.element}
    </Box>
  );

  if (disableTooltip) return badge;

  return (
    <Tooltip title={t(translation_path + config.translationKey)}>
      {badge}
    </Tooltip>
  );
};

export default ScheduleTypeIcon;
